__webpack_require__.p = "https://static.spqr.app/c84ebb9cbced4f225d0f0b860b1ac6b87317fd89/_next/";